// journeyDate se persistuje preko refresh-a; pri rehidraciji se datum iz
// prošlosti pomera na danas. `adjusted` kaže da je pomeren — a da li to pali
// vidljivo obaveštenje odlučuje searchSlice (samo za datum koji je korisnik
// lično birao, ne za podrazumevani jučerašnji „danas").

export function todayIso() {
    // Lokalni datum (ne UTC): toISOString() bi u zonama ispred UTC-a (npr. Srbija)
    // u ranim satima vratio jučerašnji datum, pa bi „danas" bilo pogrešno.
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export function normalizeJourneyDate(persisted, today = todayIso()) {
    if (typeof persisted !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(persisted)) {
        return { date: today, adjusted: false };
    }
    // ISO datumi se porede leksikografski.
    if (persisted < today) {
        return { date: today, adjusted: true };
    }
    return { date: persisted, adjusted: false };
}
